import { isFt3dRulerFrame } from '../shared/ft3d-ruler-frame';
import type { WSMessage } from './types';

/** Rulers never enter the target draft or encounter cache. The scene owns sequence/expiry and echo suppression. */
export function handleFt3dRuler(data: Extract<WSMessage, { type: 'ft3d_ruler' | 'ft3d_ruler_clear' }>): void {
    if (!isFt3dRulerFrame(data)) return;
    window.dispatchEvent(new CustomEvent('ft:ft3d-ruler', { detail: data }));
}

window.handleFt3dRuler = handleFt3dRuler;
